:host {
  display: block;
  max-width: 100%;
  width: 73px;
  --text-color: var(--white-layout-300-primary);
  --icon-color: red;
  position: relative;
}

.discount-tag {
  width: 73px;
  height: 73px;
  position: absolute;
  top: 0;
  font-weight: 600;
  font-size: 14px;
  justify-content: center;

  .percent {
    top: 5px;
    color: var(--text-color);
  }

  .text {
    top: 22px;
    color: var(--text-color);
  }
}

gz-icon {
  display: flex;
  align-items: center;
  justify-content: center;

  &::part(svgIcon) {
    --custom-svg-color: var(--icon-color);
  }

  &:before {
    content: '';
    width: 51px;
    height: 51px;
    border-radius: 50%;
    background-color: var(--icon-color);
    position: absolute;
  }
}

p {
  position: absolute;
}
